module.exports = __webpack_public_path__ + "static/gallery4-8d9366aff8d4fe032c10151210d959d2.png";